module.exports = __webpack_public_path__ + "static/media/no-feed-items.6697e81c.png";